export default "__VITE_ASSET__DNleHO7P__"